import {reactive} from "vue";
import type {DefaultResponse} from "@/domain/type/request.type";

class SystemEvent {

    listenerRequestError = reactive({
        value: {
            errorObject: {
                data: "",
                message: "",
                success: false
            }
        }
    })

    emitRequestError(error: DefaultResponse<string>) {
        this.listenerRequestError.value = {errorObject: error}
    }


}

export default SystemEvent;